// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WxWY","icon":"styles_icon__1kKJp"};